import {
  SessionsHistoriesRawData,
  ChartsData,
  TreatmentItemData,
} from "~/core/resources/sessionApi";
import {
  LinkedChannelType,
  ExternalRequestResponseType,
} from "~/type/linkedChannelType";
import {
  SessionCategory,
  SessionStatus,
  SessionType,
} from "~/constant/session";

export interface HistoryData {
  acquisitionChannel: null | { name: string };
  appointment: null | {
    acquisitionChannel: null | { name: string };
    assist: null | { name: string };
    category: SessionCategory;
    counselor: null | { name: string };
    date: string;
    doctor: null | { name: string };
    externalLinkedChannel: LinkedChannelType | null;
    id: number;
    memo: null | string;
    status: string;
    treatmentItems: TreatmentItemData[];
    isDeleted: boolean;
  };
  assist: null | { name: string };
  category: SessionCategory;
  consultings: ChartsData[];
  counselor: null | { name: string };
  date: string;
  department: { name: string };
  doctor: null | { name: string };
  endHour: string;
  externalLinkedChannel: null | LinkedChannelType;
  externalRequest: null | ExternalRequestResponseType;
  id: number;
  memo: null | string;
  nurseCares: ChartsData[];
  nurseOperations: ChartsData[];
  payments: ChartsData[];
  sessionStatusConfig: null | {
    code: SessionStatus;
    color: string;
    name: string;
    type: SessionStatus;
  };
  skincares: ChartsData[];
  startHour: string;
  status: SessionStatus;
  surgeries: ChartsData[];
  treatmentItems: TreatmentItemData[];
  treatments: ChartsData[];
  type: SessionType;
}

export function mapRawToSessionHistories(
  session: SessionsHistoriesRawData
): HistoryData {
  return {
    acquisitionChannel: session.acquisitionChannelName
      ? { name: session.acquisitionChannelName }
      : null,
    appointment: session.appointment
      ? {
          acquisitionChannel: session.appointment.acquisitionChannelName
            ? { name: session.appointment.acquisitionChannelName }
            : null,
          assist: session.appointment.assistName
            ? {
                name: session.appointment?.assistName,
              }
            : null,
          category: session.appointment?.category,
          counselor: session.appointment?.counselorName
            ? {
                name: session.appointment.counselorName,
              }
            : null,
          date: session.appointment.date,
          doctor: session.appointment?.doctorName
            ? {
                name: session.appointment?.doctorName,
              }
            : null,
          externalLinkedChannel: session.appointment.externalLinkedChannel,
          id: session.appointment.id,
          memo: session.appointment?.memo,
          status: session.appointment.status,
          isDeleted: session.appointment.isDeleted,
          treatmentItems: session.appointment.treatmentItems,
        }
      : null,
    assist: session.assistName ? { name: session.assistName } : null,
    category: session.category,
    consultings: session.charts.filter((chart) => chart.type === "CONSULTING"),
    counselor: session.counselorName ? { name: session.counselorName } : null,
    date: session.date,
    department: { name: session?.departmentName },
    doctor: session.doctorName ? { name: session.doctorName } : null,
    endHour: session.endHour,
    externalLinkedChannel: session.externalLinkedChannel,
    externalRequest: session.externalRequestStatus,
    id: session.id,
    memo: session.memo,
    nurseCares: session.charts.filter((chart) => chart.type === "NURSE_CARE"),
    nurseOperations: session.charts.filter(
      (chart) => chart.type === "NURSE_OPERATION"
    ),
    payments: session.charts.filter((chart) => chart.type === "PAYMENT"),
    sessionStatusConfig: session.statusCode
      ? {
          code: session.statusCode,
          color: session.statusColor,
          name: session.statusName,
          type: session.status,
        }
      : null,
    skincares: session.charts.filter((chart) => chart.type === "SKINCARE"),
    startHour: session.startHour,
    status: session.status,
    surgeries: session.charts.filter((chart) => chart.type === "SURGERY"),
    treatmentItems: session.treatmentItems,
    treatments: session.charts.filter((chart) => chart.type === "TREATMENT"),
    type: session.type,
  };
}

export interface EncounterData {
  acquisitionChannel: null | { name: string };
  assist: null | { name: string };
  category: string;
  counselor: null | { name: string };
  date: string;
  department: { name: string };
  doctor: null | { name: string };
  endHour: string;
  externalLinkedChannel: null | LinkedChannelType;
  externalRequest: null | ExternalRequestResponseType;
  id: number;
  memo: null | string;
  sessionStatusConfig: null | {
    code: SessionStatus;
    color: string;
    name: string;
    type: SessionStatus;
  };
  startHour: string;
  status: SessionStatus;
  treatmentItems: TreatmentItemData[];
  type: SessionType;
}

export function mapRawToSessionEncounter(
  session: SessionsHistoriesRawData
): EncounterData {
  return {
    acquisitionChannel: session.acquisitionChannelName
      ? { name: session.acquisitionChannelName }
      : null,
    assist: session.assistName ? { name: session.assistName } : null,
    category: session.category,
    counselor: session.counselorName ? { name: session.counselorName } : null,
    date: session.date,
    department: { name: session.departmentName },
    doctor: session.doctorName ? { name: session.doctorName } : null,
    endHour: session.endHour,
    externalLinkedChannel: session.externalLinkedChannel,
    externalRequest: session.externalRequestStatus,
    id: session.id,
    memo: session.memo,
    sessionStatusConfig: session.statusCode
      ? {
          code: session.statusCode,
          color: session.statusColor,
          name: session.statusName,
          type: session.status,
        }
      : null,
    startHour: session.startHour,
    status: session.status,
    treatmentItems: session.treatmentItems,
    type: session.type,
  };
}
